<template>
    <Component
        :is="require(`Svgs/${name}.svg?inline`)"
        class="SvgLoader"
        v-bind="$attrs"
        @v-on="$listeners"
    />
</template>

<script>
export default {
    name: 'SvgLoader',

    // inheritAttrs: false,

    props: {
        name: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
svg {
    display: inline-flex;
}
</style>
